export default __webpack_public_path__ + "static/media/orange.fee5613d.svg";